module.exports = __webpack_public_path__ + "static/media/icon-clock-extra.2c9ec88e.svg";